import React, { useEffect, useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { redirect } from '../../redux/slice/Redirect'
import { advertiseImage } from '../../redux/slice/AdvertisementImage'
import '../../assets/css/RedirectPage.css'

export default function LinkGenerator2() {
    const [loading, setLoading] = useState(true)
    const [longUrl, setLongUrl] = useState('')
    const [urlType, setUrlType] = useState('')
    const [countdown, setCountdown] = useState('')
    const [redirecting, setRedirecting] = useState(false)
    // const advertisementData = useSelector((state) => state?.advertiseImage?.data?.[0])
    const [advertismentImage, setAdvertismentImage] = useState('')

    const { id } = useParams()
    const dispatch = useDispatch()


    const handleRedirect = useCallback(() => {
        if (longUrl) {
            setRedirecting(true)
            window.location.href = longUrl
        }
    }, [longUrl])

    useEffect(() => {
        if (longUrl && !redirecting) {
            // For paid links, redirect immediately
            if (urlType === 'paid') {
                handleRedirect()
                return
            }
            // For free links, start countdown
            const timer = setInterval(() => {
                setCountdown((prev) => {
                    if (prev <= 1) {
                        clearInterval(timer)
                        handleRedirect()
                        return 0
                    }
                    return prev - 1
                })
            }, 1000)

            return () => clearInterval(timer)
        }
    }, [longUrl, redirecting, urlType, handleRedirect])

    // Fetch advertisement images when component loads



    useEffect(() => {
        setLoading(true)
        dispatch(redirect({ short_code: id })).then((res) => redirect_res(res.payload))
    }, [])

    const redirect_res = (res) => {
        if (res?.status == 200) {
            setLoading(false)
            setLongUrl(res?.data?.data?.long_link);
            setUrlType(res?.data?.data?.link_type)
             setAdvertismentImage(res?.data?.data?.advertiseData?.advertise_image)
             setCountdown(res?.data?.data?.advertiseData?.timer)

        } else {
            setLoading(false)
            setAdvertismentImage('')
            setCountdown('')
        }
    }


    return (
        <>
            <div className='redirect-container'>
                {loading ? (
                    <div className='redirect-loader'>
                        <div className='spinner'></div>
                        <p>Loading...</p>
                    </div>
                ) : longUrl ? (
                    <div className='redirect-content'>
                        {urlType === 'free' && (
                            <>
                                <div className='advertisement-block'>
                                    <h3>Advertisement</h3>
                                    {advertismentImage ? (
                                        <div className='ad-images-container'>
                                            {/* <div className='ad-image-wrapper'> */}
                                            <img
                                                src={process.env.REACT_APP_BASE_URL + advertismentImage}
                                                alt="Advertisement"
                                                className='ad-image'
                                                onError={(e) => {
                                                    e.target.style.display = 'none'
                                                    const placeholder = e.target.nextSibling
                                                    if (placeholder) {
                                                        placeholder.style.display = 'block'
                                                    }
                                                }}
                                            />
                                            <div className='ad-placeholder' style={{ display: 'none' }}>
                                                <p>Advertisement image not available</p>
                                            </div>
                                        </div>
                                        // </div>
                                    ) : (
                                        <div className='ad-placeholder'>
                                            <p>Your advertisement content here</p>
                                            <p className='ad-note'>This space is reserved for advertisements</p>
                                        </div>
                                    )}
                                </div>
                                <div className='redirect-info'>
                                    <p className='redirect-message'>
                                        Redirecting to your destination in <span className='countdown'>{countdown}</span> seconds...
                                    </p>
                                    {/* <button
                                        className='btn-skip-ad'
                                        onClick={handleRedirect}
                                    // disabled={redirecting}
                                    >
                                        Skip Ad & Continue
                                    </button> */}
                                    {/* <p className='redirect-url'>
                                        <a
                                            href={formatUrl(longUrl)}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className='link-preview'
                                        >
                                            {longUrl}
                                        </a>
                                    </p> */}
                                </div>
                            </>
                        )}
                    </div>
                ) : (
                    <div className='redirect-error'>
                        {/* <p>Unable to redirect. Invalid or expired link.</p> */}
                        {window.location.replace('https://ad1.page/')}
                    </div>
                )}
            </div>
        </>
    )
}
